import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gaPageView } from '../lib/ga';
import { titrePourChemin } from '../lib/titresPages';

/**
 * SuiviPages — ne rend rien. À chaque changement de route : titre de l'onglet,
 * puis page vue GA4 (sans effet tant que les cookies analytiques ne sont pas acceptés).
 * À placer dans le routeur, avant CookieConsent.
 */
export default function SuiviPages() {
  const { pathname } = useLocation();

  useEffect(() => {
    const titre = titrePourChemin(pathname);
    document.title = titre;
    gaPageView(pathname, titre);
  }, [pathname]);

  return null;
}
